import { z } from 'zod'

export const ChangeType = z.enum(['ENHANCED', 'FIXED', 'REMOVED', 'ADDED'])

export type ChangeType = z.infer<typeof ChangeType>
